import { Observable, of } from 'rxjs';

export class MockAuthenticationService {
  constructor() {}


}
